import './styles/style.scss';
import Loader from './Loader';

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js